import { isNullOrUndefined, findRule } from '../Utils'

const en = /^[0-9]+$/

const validate = vObj => {
  let value = vObj.value
  let rule = findRule(vObj.errorBag, 'imei_format')
  rule.feedback = `${vObj.fieldlabel} should be a valid IMEI`

  const numeric = val => {
    const testValue = val => {
      const strValue = String(val)

      return en.test(strValue)
    }

    if (Array.isArray(val)) {
      return value.every(testValue)
    }

    return testValue(val)
  }

  const length = (val, len) => {
    if (isNullOrUndefined(val)) {
      return false
    }

    return String(val).length === len
  }

  const luhn = num => {
    // accept only digits
    if (/[^0-9]+/.test(value)) return false

    // The Luhn Algorithm. It's so pretty.
    var nCheck = 0; var nDigit = 0; var bEven = false
    value = value.replace(/\D/g, '')

    for (var n = value.length - 1; n >= 0; n--) {
      var cDigit = value.charAt(n)
      nDigit = parseInt(cDigit, 10)

      if (bEven) {
        if ((nDigit *= 2) > 9) nDigit -= 9
      }

      nCheck += nDigit
      bEven = !bEven
    }

    return (nCheck % 10) === 0
  }

  return numeric(value) && length(value, 15) && luhn(value)
}

export { validate }

export default {
  validate
}
